//@flow
import * as React from 'react'
import { Field } from 'redux-form';
import renderTextField from '../../../components/MaterialUi/renderTextField';
import styles from './styles'
import type { ContainerRowReduxField$Props } from '../flowTypes'

const ContainerRowReduxTextField=(props:ContainerRowReduxField$Props)=>{
    return (
        <div className="row">
            <div className='col-sm'>
                <Field
                    name={props.field}
                    component={renderTextField}
                    label={props.label}
                    style={styles.textFieldStyle}
                    type={props.textType?props.textType:'string'}
                    onChange={(e)=> textOnChange(e,props)}
                />
            </div>
        </div> 
    )
}

const textOnChange=(e,props:ContainerRowReduxField$Props)=>{
    if (props.textOnChangeFunc){
        const textOnChangeFunc = props.textOnChangeFunc
        const parentProps = (props.parentProps:any)
        textOnChangeFunc(e,parentProps)
    }
}


export default ContainerRowReduxTextField


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/common/ContainerRowReduxTextField.js